__turbopack_context__.v({
  "promotions": "styles-module-scss-module__0VXkjG__promotions",
  "promotionsInner": "styles-module-scss-module__0VXkjG__promotionsInner",
  "promotionsTitle": "styles-module-scss-module__0VXkjG__promotionsTitle",
});
